module.exports = __webpack_public_path__ + "static/img/James_Sicily_mobile.20e9510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James_Sicily_mobile.jpg
// module id = sTnv
// module chunks = 0